/*
 * @Author: Zhouqi
 * @Date: 2026-04-20 12:41:50
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-04-20 13:49:53
 */
export enum ModelIdEnum {
  // Text to Video
  TEXT_TO_VIDEO_Kling_v2_6_Pro = 13,
  TEXT_TO_VIDEO_Seedance_v1_5_Pro = 15,
  TEXT_TO_VIDEO_Seedance_v2_0 = 23,
  TEXT_TO_VIDEO_Sora_2_Pro = 1,
  TEXT_TO_VIDEO_Veo_3_1 = 3,
  TEXT_TO_VIDEO_Kling_2_5_Turbo_Pro = 5,
  TEXT_TO_VIDEO_Kling_v3_0_Pro = 21,

  // Image to Video
  IMAGE_TO_VIDEO_Kling_v2_6_Pro = 14,
  IMAGE_TO_VIDEO_Seedance_v1_5_Pro = 16,
  IMAGE_TO_VIDEO_Sora_2_Pro = 2,
  IMAGE_TO_VIDEO_Veo_3_1 = 4,
  IMAGE_TO_VIDEO_Kling_2_5_Turbo_Pro = 6,
  IMAGE_TO_VIDEO_Kling_v3_0_Pro = 22,
  IMAGE_TO_VIDEO_Seedance_v2_0 = 24,

  // Text to Image
  TEXT_TO_IMAGE_Nano_Banana_Pro = 11,
  TEXT_TO_IMAGE_Nano_Banana2 = 19,
  TEXT_TO_IMAGE_Flux_Kontext_Pro = 9,
  TEXT_TO_IMAGE_GPT_Image_2 = 26,

  // Image to Image
  IMAGE_TO_IMAGE_Nano_Banana_Pro = 12,
  IMAGE_TO_IMAGE_Nano_Banana2 = 20,
  IMAGE_TO_IMAGE_Flux_Kontext_Pro = 10,
  IMAGE_TO_IMAGE_GPT_Image_2 = 25,

  // Video Edit
  VIDEO_EDIT_Kling_v2_6_Pro_Motion_Control = 18,
  VIDEO_EDIT_Kling_O1_Video_Edit = 17,
}
